import { centsScalar, dateScalar } from '@betterment/js-runtime';
import { withScalars } from 'apollo-link-scalars';
import { IntrospectionQuery, buildClientSchema } from 'graphql';

import { data as schemaData } from '../../../../graphql/schema.json';

export const scalarsLink = withScalars({
  schema: buildClientSchema(schemaData as unknown as IntrospectionQuery),
  typesMap: {
    Cents: centsScalar,
    Date: dateScalar,
  },
});
